import React from 'react';
import { observer } from 'mobx-react';
import { navigate } from 'js/services/Network';

import { url } from 'js/services/Network';
import analytics from 'js/services/Analytics';

import AppState from 'js/stores/AppState';
import AppUser from 'js/stores/AppUser';

import AppContent from 'js/components/AppContent';
import PageComponent from 'js/components/pages/PageComponent';
import Constraint from 'js/components/Constraint';
import LoginSignupDialog from 'js/components/common/LoginSignupDialog';

@observer
export default class MarketingPage extends PageComponent {
  pageName = 'MarketingPage';

  redirect = () => navigate(url('home-page'));

  pageEvent = () => {
    //AppState.isOnLandingPage ? analytics.page('LP_viewed sign up page') : analytics.page('Signup');

    if (AppUser.isLoggedIn) {
      this.redirect();
    }
  };

  renderPage() {
    return (
      <AppContent padded>
        <Constraint>
          <LoginSignupDialog
            showForm="signup"
            afterLogin={this.redirect}
            loginTitle="Log in to your account"
            facebook={false}
            google={false}
            marketing={true}
            signupTitle="Create an account"
            signupText="to allow an user to buy and sell on any marketplace."
            padded
            termsAndConditions
          />
        </Constraint>
      </AppContent>
    );
  }
}
